<template>
  <header>
    <NavComponent />
  </header>
</template>

<script setup>
import NavComponent from './NavComponent.vue';
</script>
